import { defaultBaseQuery, transformErrorResponse, transformSuccessResponse } from "@/services";
import { createApi } from "@reduxjs/toolkit/query/react";

const hodDashboardAPI = createApi({
    reducerPath: "hodDashboardAPI",
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getHodDashboard: builder.query({
            query: ({ days = 7, date, programId, courseId, semesterYearId, admissionSystem, sortBy, sortDir } = {}) => ({
                url: "/dashboard",
                method: "GET",
                params: {
                    days,
                    date,
                    ...(programId && { programId }),
                    ...(courseId && { courseId }),
                    ...(semesterYearId && { semesterYearId }),
                    ...(admissionSystem !== undefined && admissionSystem !== "" && { admissionSystem }),
                    ...(sortBy && { sortBy, sortDir: sortDir ?? "" }),
                },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAttendanceSummary: builder.query({
            query: ({ programId, courseId, date } = {}) => ({
                url: "/dashboard/attendance-summary",
                method: "GET",
                params: {
                    ...(programId && { programId }),
                    ...(courseId && { courseId }),
                    date,
                },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getDashboardDropdowns: builder.query({
            query: () => ({
                url: "/dropdowns",
                method: "GET",
                params: { pageName: "DASHBOARD_PAGE" },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getHodDashboardList: builder.query({
            query: ({ semesterYearId, admissionSystem, divisionId, date, programId, courseId, page = 0, size = 0, sortBy = "studentName", sortDir = "", searchText = "" }) => ({
                url: "/dashboard/semester-students",
                method: "GET",
                params: {
                    semesterYearId, admissionSystem, divisionId, date,
                    ...(programId && { programId }),
                    ...(courseId && { courseId }),
                    page, size, sortBy, sortDir, searchText,
                },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getPunchDetails: builder.query({
            query: ({ fromDate, toDate, encryptedUskId }) => ({
                url: "/attendance/punch-details",
                method: "GET",
                params: { fromDate, toDate, encryptedUskId },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const {
    useGetHodDashboardQuery,
    useLazyGetHodDashboardQuery,
    useGetAttendanceSummaryQuery,
    useGetHodDashboardListQuery,
    useGetPunchDetailsQuery,
    useGetDashboardDropdownsQuery,
} = hodDashboardAPI;
export default hodDashboardAPI;
